<mat-chip
  [ngClass]="pillButtonDTO.selected ? 'selected' : 'unselected'"
  (click)="onSelectedChanged()"
  [matTooltip]="pillButtonDTO.title"
>
  <div [class.wide]="!pillButtonDTO.selected">
    <div>
      <span class="heading">{{ pillButtonDTO.title }}</span>
      <span class="descriptor">{{ pillButtonDTO.subtitle }}</span>
    </div>
    <div *ngIf="hasEdit && pillButtonDTO.selected">
      <button
        aria-label="Edit Grading Period"
        class="sub-btn"
        type="button"
        color="primary"
        aria-label="edit grading period button"
        (click)="onEditClick()"
      >
        <img src="/assets/img/edit.png" />
      </button>
    </div>
  </div>
</mat-chip>
